module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="tipped member js-show-member-detail '+
((__t=( party ))==null?'':_.escape(__t))+
' '+
((__t=( district_type ))==null?'':_.escape(__t))+
' '+
((__t=( district_address_city ))==null?'':_.escape(__t))+
' '+
((__t=( vacant ))==null?'':_.escape(__t))+
'" id="member'+
((__t=( id ))==null?'':_.escape(__t))+
'">\n  ';
 if (vacant === 'vacant') { 
__p+='\n    <img src="'+
((__t=( require('../../../../images/cropped/icon_vacant.jpg') ))==null?'':__t)+
'" title="'+
((__t=( tooltip_info ))==null?'':_.escape(__t))+
'"/>\n  ';
 } else { 
__p+='\n    <img src="'+
((__t=( require('../../../../images/cropped/icon_' + id + '.jpg') ))==null?'':__t)+
'" title="'+
((__t=( tooltip_info ))==null?'':_.escape(__t))+
'"/>\n  ';
 } 
__p+='\n  <div class="member-info">\n    '+
((__t=( district_type ))==null?'':_.escape(__t))+
' '+
((__t=( district_number ))==null?'':_.escape(__t))+
'\n  </div>\n</div>\n';
}
return __p;
};
